import { useState } from "react";

import Button from "../../Button";
import { Text } from "../../Type";
import styles from "./index.module.scss";
import { FileUpload } from "../../Icons/files";
import Modal from "../../Modal";
import UploadDocumentsModal from "../UploadDocumentsModal";
import { useClientFileContext } from "../../../contexts/ClientFileProvider";
import ProfileButton from "../../UserInterface/ProfileButton";
import { useStoreContext } from "../../../contexts/StoreProvider";
import { isPostSigningStatus } from "../../../utils/status";

const ApplicantHeader = ({
  name = "",
  healthCard = "",
  clientFileId,
  noButtons,
}: {
  name?: string;
  healthCard?: string;
  clientFileId: string;
  noButtons?: boolean;
}) => {
  const { state: { user }, } = useStoreContext();

  const [isUploadModalOpen, setUploadModalOpen] = useState(false);
  const { clientFile, formMode: mode } = useClientFileContext();
  const { status } = clientFile;
  const { authorizers, sales_reps } = clientFile.client;

  const readOnly = (isPostSigningStatus(String(status)) || (clientFile?.locked_by && clientFile?.locked_by.id !== user?.id) || ["waitingSigning"].includes(mode));

  return (
    <>
      <div className={styles.header}>
        <Text
          className={styles.applicant}
          component="span"
          weight="regular"
          size="large"
        >
          Applicant: {name}
        </Text>
        <Text className={styles.hc} component="span" weight="regular">
          HC: {healthCard}
        </Text>

        <span className={styles.rightGroup}>
          {status !== "Completed" && authorizers.length > 0 &&
            authorizers.map(item => {
              if (user?.id !== item.id) {
                return (
                  <div className={styles.profileButton} key={item.id}>
                    <ProfileButton
                      id={item.id}
                      user={{first_name: item.first_name, last_name: item.last_name, role: {name: item.role.name}}}
                      userRole
                    />
                  </div>
                );
              };
              return null;
            })
          }
          {status !== "Completed" && sales_reps.length > 0 &&
            sales_reps.map(item => {
              if (user?.id !== item.id ) {
                return (
                  <div className={styles.profileButton} key={item.id}>
                    <ProfileButton
                      id={item.id}
                      user={{first_name: item.first_name, last_name: item.last_name, role: {name: item.role.name}}}
                      userRole
                    />
                  </div>
                );
              };
              return null;
            })
          }
          {!noButtons &&
            <div className={styles.button}>
              <Button
                className={styles.uploadButton}
                secondary
                icon={<FileUpload />}
                onClick={() => setUploadModalOpen(true)}
                disabled={readOnly && false}
              >
                Upload/View Documents
              </Button>
            </div>
          }
        </span>
      </div>

      <Modal
        title="Supporting Documents"
        isOpen={isUploadModalOpen}
        onClose={() => { setUploadModalOpen(false); }}
      >
        <UploadDocumentsModal
          clientFileId={clientFileId}
          setUploadModalOpen={setUploadModalOpen}
        />
      </Modal>
    </>
  );
};

export default ApplicantHeader;
